import { ChangeDetectionStrategy, Component, Inject, Input, Optional } from '@angular/core';

import type { Attachment } from '@recruitee/attachments-types';
import { TranslatePipe } from '@recruitee/i18n';

import { ButtonComponent } from '../../../common/button/components/button/button.component';
import { DateComponent } from '../../../common/date/rt-date/date.component';
import { HeadingComponent } from '../../../common/heading/heading.component';
import { IconComponent } from '../../../common/icon/icon.component';
import { DialogBodyComponent } from '../../../dialog/dialog-body/dialog-body.component';
import { DialogData } from '../../../dialog/dialog-injector';
import { PdfViewerComponent } from '../../../pdf-viewer/pdf-viewer.component';

export type AttachmentPreviewDialogData = {
  attachment: Attachment;
  translations: {
    closeDialogTooltip: string;
    downloadFile: string;
  };
  newDownloadedFileName?: string;
};

@Component({
  selector: 'rt-attachment-preview',
  templateUrl: './attachment-preview-dialog.component.html',
  styleUrls: ['./attachment-preview-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    DateComponent,
    DialogBodyComponent,
    HeadingComponent,
    IconComponent,
    PdfViewerComponent,
    TranslatePipe,
  ],
})
export class AttachmentPreviewDialogComponent {
  @Input() public attachment: Attachment;
  public isPdf: boolean;
  public isImage: boolean;
  public pdfUrl: string | null;
  public newDownloadedFileName?: string;
  public translations: AttachmentPreviewDialogData['translations'];

  constructor(
    @Optional()
    @Inject(DialogData)
    data: AttachmentPreviewDialogData,
  ) {
    if (data && data.attachment) {
      this.attachment = data.attachment;
      this.translations = data.translations;
      this.isPdf = !!data.attachment.pdfUrl;
      this.isImage = !!data.attachment.imageUrl;
      this.newDownloadedFileName = data.newDownloadedFileName;
      this.pdfUrl = this.isPdf ? encodeURIComponent(data.attachment.pdfUrl!) : null;
    }
  }
}
